import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import axios from "axios";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { SiMicrosoftexcel } from "react-icons/si";
import logo from "../images/TP-_logo-orizz-claim-color.png";

function BasicExample() {
  const [sortedClientiData, setSortedClientiData] = useState([]);
  const [error, setError] = useState("");
  const [isError, setIsError] = useState(false);
  const [sortConfig, setSortConfig] = useState({
    key: "valore",
    direction: "descending",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("mancata_vendita_dashboard.json");

        if (res.data && res.data.SUD && Array.isArray(res.data.SUD.localita)) {
          const clientiData = res.data.SUD.localita;
          console.log(clientiData);

          const transformedData = clientiData.reduce((acc, item) => {
            const key = `${item.id_cliente}-${item.origine}`;

            const valore = item.Valore
              ? parseFloat(item.Valore.replace(",", "."))
              : 0;
            const numeroDoc = item.numero_doc
              ? parseInt(item.numero_doc, 10)
              : 0;

            if (acc[key]) {
              acc[key].valore += valore;
              acc[key].numero += numeroDoc;
              acc[key].dettagli.push({
                descrizione: item.descrizione,
                valore: valore,
              });
            } else {
              acc[key] = {
                id_cliente: item.id_cliente,
                cliente: item.clienti,
                valore: valore,
                numero: numeroDoc,
                localita:
                  item.paese && item.provincia
                    ? `${item.paese} (${item.provincia})`
                    : item.paese || item.provincia || "N/A",
                origine: item.origine,
                dettagli: [
                  {
                    brand: item.brand,
                    precodice: item.precodice,
                    valore: valore,
                  },
                ],
              };
            }
            return acc;
          }, {});

          const sortedData = sortArray(
            Object.values(transformedData),
            sortConfig.key,
            sortConfig.direction,
          );
          setSortedClientiData(sortedData);
        } else {
          setError(
            "Dati delle località non disponibili o in formato non corretto.",
          );
          setSortedClientiData([]);
        }
      } catch (err) {
        console.error("Errore durante il fetch dei dati:", err);
        setIsError(true);
        setError(err.message);
      }
    };

    fetchData();
  }, [sortConfig]);

  const sortArray = (array, key, direction) => {
    return array.sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === "ascending" ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === "ascending" ? 1 : -1;
      }
      return 0;
    });
  };

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const formatToEuro = (amount) => {
    return new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
    }).format(amount);
  };

  return (
    <div
      className="bg-light ombra widget-client2 tb hover-effect"
      style={{ borderRadius: "10px", border: "1px solid rgb(200, 200, 200)" }}
    >
      <Table striped hover style={{ fontSize: "0.8rem" }}>
        <thead>
          <tr>
            <th
              style={{ backgroundColor: "red", cursor: "pointer" }}
              className="text-light sticky-top"
            >
              Clienti
            </th>
            <th
              style={{ backgroundColor: "red", cursor: "pointer" }}
              className="text-light sticky-top"
              onClick={() => handleSort("localita")}
            >
              Località
            </th>
            <th
              style={{ backgroundColor: "red" }}
              className="text-light sticky-top"
              onClick={() => handleSort("valore")}
            >
              Valore
            </th>
            <th
              style={{ backgroundColor: "red" }}
              className="text-light sticky-top"
            >
              Numero
            </th>
            <th
              style={{ backgroundColor: "red" }}
              className="text-light sticky-top"
            >
              Origine
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedClientiData.map((clientiItem, index) => (
            <tr key={index}>
              <td style={{ cursor: "pointer" }}>{clientiItem.cliente}</td>
              <td>{clientiItem.localita}</td>
              <td>{formatToEuro(clientiItem.valore)}</td>
              <td>{clientiItem.numero}</td>
              <td>{clientiItem.origine}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

export default BasicExample;
